<template>
    <div class="addorder pb-70">
        <NavBar title="预订信息" left-arrow @click-left="goback(-1)" />
        <div class="title">商品信息</div>
        <div>            
            <div class="goods_title">【{{goods.category_name}}】{{goods.name}}</div>
            <div class="panel flex align-items-center flex-space-between">
                <div>单价：<span class="fs18">{{goods.price}}</span>元</div>
                <div class="flex align-items-center">
                    <span>数量：</span>
                    <Stepper @change="changeNum" min="1" max="99" v-model="post.num" />
                </div>
            </div>
        </div>
        <template v-if="goods.use_notice">
            <div class="title">特别提示</div>
            <div class="use-notice">{{goods.use_notice}}</div>
        </template>
        <div class="title">预订信息</div>
        <div class="panel flex align-items-center border-bottom fs14">
            <div class="w100">使用时间</div>
            <div @click="selecttoday" class="optional" :class="{'notoptional':!hastoday,'active':istoday}">
                <div>今日</div>
                <div v-if="hastoday">{{datenow}}</div>
                <div v-else>不可选</div>
            </div>
            <!-- <div class="optional">选择</br>今日</div> -->
            <div @click="calendarShow = true" class="optional" :class="{'active':!istoday && isoptional}">
                <div>更多日期</div>
                <div v-if="!istoday && isoptional">{{post.youwan}}</div>   
            </div>
        </div>
        <div>
            <Field
            v-model="post.username"
            :border="false"
            type="text"
            label="联系人"
            placeholder="请输入联系人姓名"
            />
            <Field
            v-model="post.userphone"
            :border="false"
            type="number"
            label="联系人电话"
            placeholder="请输入电话"
            />
            <Field
            v-if="goods.address == 1"
            v-model="post.address"
            :border="false"
            type="text"
            label="地址"
            placeholder="邮寄地址"
            />
            <Field
            v-model="post.remark"
            :border="false"
            type="textarea"
            row="1"
            label="备注"
            placeholder="备注信息"
            />
        </div>
        <div v-if="goods.idcode > 0" class="title">身份信息</div>
        <div v-if="goods.idcode > 0">
            <div v-if="goods.idcode == 1">
                <Field
                v-model="post.realname"
                :border="false"
                type="text"
                label="姓名"
                placeholder=""
                />
                <Field
                v-model="post.idcode"
                :border="false"
                type="text"
                label="身份证号"
                placeholder=""
                />
            </div>
            <template v-else-if="goods.idcode == 2">
                <div v-for="(item,index) in post.realname" :key="index">
                    <Field
                    v-model="post.realname[index]"
                    :border="false"
                    type="text"
                    label="姓名"
                    placeholder=""
                    />
                    <Field
                    v-model="post.idcode[index]"
                    :border="false"
                    type="text"
                    label="身份证号"
                    placeholder=""
                    />
                </div>
            </template>
        </div>
        <div class="flex align-items-center flex-center mt-10 fs18">
            <div>数量：<span class="c-blue weight mr-20">{{ post.num }}</span></div>
            <div>总金额：<span class="c-orange">￥</span><span class="c-orange fs20 weight">{{totalprice}}</span></div>
        </div>
        <div class="btn">
            <Button round type="info" @click="addorder">立即下单</Button>
        </div>
        <calendar v-model="calendarShow" :checked="post.youwan" :cusCalendar="kucun" :mark="goods.price" :dateSlot="dateSlot" dateType="custom" @select="select"></calendar>
        <div class="page-end">@游尚智联 技术支持</div>
    </div>
</template>

<script>    
//引本地图片
import pic from "../../assets/user.png";
import pic2 from "../../assets/img01.jpg";
import api from '@/api/manage'
import calendar from '@/components/Calendar.vue'
import qs from 'qs'
//引组件
import {
    NavBar,
    Stepper,
    Field,
    Button,
    Toast
} from 'vant';
let oldnum = 1;
export default{
    data(){
        return{
            imgurl1:pic,
            imgurl2:pic2,
            activeNames: ['1'],
            goods:{},
            kucun:{},
            current:{},
            datenow:this.getnow(),
            post:{
                good_id:0,
                username:'',
                userphone:'',
                num:1,
                youwan:'',
                address:'',
                realname:'',
                idcode:'',
                remark:''
            },
            calendarShow:false,
            url:'addorder'
        }
    },
    components:{
        NavBar,
        Stepper,
        Field,
        Button,
        calendar
    },
    computed:{
        dateSlot(){
            let keys = Object.keys(this.kucun);
            let res;
            if(keys.length > 0){
                res = {start:`${keys[0].substr(0,4)}-${keys[0].substr(4,2)}-${keys[0].substr(6,2)}`,end:`${keys[keys.length - 1].substr(0,4)}-${keys[keys.length - 1].substr(4,2)}-${keys[keys.length - 1].substr(6,2)}`}
            }else{
                res = {start:this.getnow(),end:this.getnow()};
            }
            return res;
        },
        hastoday(){
            //是否存在今日
            if(!this.current.k || this.current.k != this.datenow) return false;
            return true;
        },
        istoday(){
            //选中是否为今日
            if(this.current.k != this.datenow) return false;
            return true;
        },
        isoptional(){
            //是否可选
            if(Object.keys(this.kucun).length > 0) return true;
            return false;
        },
        totalprice(){
            let price = this.goods.price || 0;
            return (price * this.post.num).toFixed(2);
        }
    },
    created(){
        document.title = '门票预订'
        this.post.good_id = this.$route.query.id;
        let that = this;
        this.load({id:that.post.good_id}).then(function(){
            that.post.youwan = that.current.k
            if(that.goods.idcode == 2){
                that.post.realname = [''];
                that.post.idcode = [''];
            }
        })
    },
    methods:{
        goto(path){
            this.$router.push(path)
        },
        getnow(){
            let d = new Date();
            let res = `${d.getFullYear()}-${(d.getMonth() + 1) < 10?'0'+ (d.getMonth() + 1):(d.getMonth() + 1)}-${d.getDate() < 10?'0'+ d.getDate():d.getDate()}`
            return res;
        },
        select(e){
            this.post.youwan = e;
        },
        selecttoday(){
            if(this.current.k != datenow) return false;
            this.post.youwan = this.datenow
        },
        changeNum(e){
            if(this.goods.idcode == 2){
                let diff;
                if(oldnum < e){
                    diff = parseInt(e) - parseInt(oldnum)
                    for(let i = 0;i < diff;i++){
                        this.post.realname.push('')
                        this.post.idcode.push('')
                    }
                }else{
                    diff = parseInt(oldnum) - parseInt(e);
                    this.post.realname.splice(this.post.realname.length - diff,diff);
                    this.post.idcode.splice(this.post.idcode.length - diff,diff);
                }
            }
            oldnum = e;
        },
        addorder(){
            let that = this;
            let data = Object.assign({bid:this.$store.state.bid},this.post);
            this.$http({
                method:'post',
                url:'orderadd',
                data:qs.stringify(data)
            }).then(function(res){
                let{status,data} = res;
                if(status == 200 && data.status == 200){
                    that.$router.push('/order/pay?o='+data.ordernum)
                }else{
                    Toast(data.message)
                }
            })
        }
    },
}

</script>
<style lang="less">
.addorder{
    font-size: 14px;
    .w100{
        width: 100px;
    }
    .panel{
        padding: 16px 16px; background: #fff;
    }
    .title{
        padding:10px 16px; color:#777;
    }
    .goods_title{
        padding: 12px 16px;background: #fff; font-weight: 700; font-size: 17px; border-bottom: 1px #eee solid;
    }
    .optional{
        padding: 0 12px; border: 1px #ddd solid; height:50px;display: flex;flex-direction:column;align-items: center;justify-content:center;text-align:center ;
        margin: 0 15px 0 0px; border-radius:4px ; font-size: 14px;
    }
    .notoptional{
        background: #eee; color:#777
    }
    .active{
        background: #ff8800; color:#fff;  border: 1px #ff8800 solid; 
    }
    .btn{
        width: 100%;padding: 0 20px; box-sizing: border-box; margin:15px 0 0 0;
        .van-button{
            width: 100%; background: #ff8800; border:none;
        }
    }

}
.van-stepper__input{
    widows: 36px !important;
    height:36px !important;
}
.van-cell{
    font-size:14px !important;
    border-bottom:1px solid #eee;
}

.use-notice{
    padding:12px 16px;
    color:rgb(241, 48, 48);
    background:#ffffff;
    text-align:center;
}

</style>

